import axiosInstance from "services/AxiosInstance";

export const getImportTransactionFileService = async (importId: string): Promise<string> => {
  const requestUrl = `imports/${importId}/transactions/file`;
  const response = await axiosInstance.get(requestUrl);
  return response.data;
};
